// Angular
import { Component } from '@angular/core';
import { Router } from '@angular/router';

// Angular Material
import { MatDialog } from '@angular/material/dialog';

// services
import { DrawerService } from '@app/services/drawer/drawer.service';

@Component({
  selector: 'oh-return-to-survey-dialog',
  templateUrl: './return-to-survey-dialog.component.html',
  styleUrls: ['./return-to-survey-dialog.component.scss'],
})
export class ReturnToSurveyDialogComponent {
  constructor(private router: Router, private dialog: MatDialog, private drawerService: DrawerService) {}

  public async confirm() {
    this.drawerService.dismiss();
    this.dialog.closeAll();
    this.router.navigate(['/welcome']);
  }

  public cancel() {
    this.dialog.closeAll();
  }
}
